import { type FC, type ReactNode } from 'react';

import styles from './PhotoWrapper.scss';

const PhotoWrapper: FC<{ children: ReactNode }> = ({ children }) => {
    return (
        <div className={styles.wrapper}>
            <div className={styles.content}>{children}</div>
        </div>
    );
};

export default PhotoWrapper;
